import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../core/auth.service';

export const isNotAdminLoginGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  const { role } = authService.getAccessTokenInfo();
  if (role !== 'admin') {
    return true;
  } else {
    router.navigateByUrl('/admin/listings');
    return false;
  }
};

/** @deprecated Use the functional `isNotAdminLoginGuard` instead */
export { isNotAdminLoginGuard as IsNotAdminLoginGuard };
